/// <reference types="@angular/localize" />

import { enableProdMode, ErrorHandler, inject, provideAppInitializer } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideRouter, withInMemoryScrolling } from '@angular/router'
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TitleCasePipe } from '@angular/common'
import { firstValueFrom } from 'rxjs'

import { AppComponent } from '@app/app.component'
import { appRoutes } from '@app/app.routes'
import { environment } from './environments/environment'
import { UserPermissionsService } from '@core/user-permissions'
import { AppGlobalErrorHandler } from '@app/services/error-handler.service'
import { WINDOW_PROVIDERS } from '@app/services/window.service'
import { LoadingInterceptor } from '@app/services/loading.interceptor'
import { ErrorHandlerInterceptor } from '@app/interfaces/error-handler.interceptor'

if (environment.production) {
  enableProdMode()
}

function appInitializerFactory(): Promise<null> {
  const userPermissionsService = inject(UserPermissionsService)
  return new Promise((resolve) => {
    firstValueFrom(userPermissionsService.getCurrentValue())
      .then(() => resolve(null))
      .catch(() => resolve(null))
  })
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(withInterceptorsFromDi()),
    WINDOW_PROVIDERS,
    TitleCasePipe,
    provideAppInitializer(appInitializerFactory),
    {
      provide: ErrorHandler,
      useClass: AppGlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
  ],
}).catch((err) => console.log(err))
